module.exports = __webpack_public_path__ + "static/media/new-loading.6b62f7a5.gif";